import { Badge, Box, Stack, Text } from '@mantine/core';
import { getEnumColor, getEnumLabel } from '../../../../../../utils/enumUtils';

import { APN_CAPABILITIES } from '../../../../../common/enums/enums';
import { NavLink } from 'react-router-dom';

const CapabilitiesCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;

    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '16px',
            }}>
            {rowData.capabilities.map((x) => {
                const badgeColor = getEnumColor(APN_CAPABILITIES, x);
                const label = getEnumLabel(APN_CAPABILITIES, x);
                return (
                    <Badge
                        size={'sm'}
                        color={badgeColor}>
                        {label}
                    </Badge>
                );
            })}
        </Box>
    );
};

const CapabilitiesColumn = () => ({
    accessorKey: 'capabilities',
    header: 'Capabilities',
    size: 1,
    Cell: ({ cell }) => <CapabilitiesCell cell={cell} />,
});
export default CapabilitiesColumn;
